import { configs } from '../../constants/configs/configs';

const { states } = configs;
export const FULL_STACK_STATES = [
    states.GEORGIA,
    states.IDAHO,
    states.ILLINOIS,
    states.NEVADA,
    states.NEW_JERSEY,
    states.NEW_MEXICO,
    states.GETINSURED,
    states.OREGON,
    states.PENNSYLVANIA,
    states.VIRGINIA
];
export const QLE_STATES_BASE = [
    states.IDAHO,
    states.ILLINOIS,
    states.PENNSYLVANIA,
    states.NEW_JERSEY,
    states.VIRGINIA,
    states.GEORGIA,
    states.NEW_MEXICO,
    states.NEVADA,
    states.GETINSURED,
    states.OREGON,
];

export const APP_STATUS_STATES = [
    states.IDAHO,
    states.NEVADA,
    states.NEW_JERSEY,
    states.PENNSYLVANIA
];

export const getQLEStates = (isMNFullStack) => {
    return isMNFullStack ? [...QLE_STATES_BASE, states.MINNESOTA] : [...QLE_STATES_BASE];
};

export const getAppStatusStates = (isMNFullStack) => {
    return isMNFullStack ? [...APP_STATUS_STATES, states.MINNESOTA] : [...APP_STATUS_STATES];
};

export const getDMIStates = (isMNFullStack) => {
    return isMNFullStack ? [...FULL_STACK_STATES, states.MINNESOTA] : [...FULL_STACK_STATES];
};
